import { utils } from "xlsx";

// Size every column of a SheetJS worksheet to its content. Without this Excel uses its narrow
// default width, and long numbers (e.g. 11,453,261.90 in a TOTAL row) show as ##########.
// Widths already set on the sheet are kept.
export const fitColumns = (ws, { min = 8, max = 60, pad = 3 } = {}) => {
  if (!ws || !ws["!ref"]) return ws;
  const range = utils.decode_range(ws["!ref"]);
  const cols = ws["!cols"] ? [...ws["!cols"]] : [];
  for (let c = range.s.c; c <= range.e.c; c++) {
    if (cols[c] && (cols[c].wch || cols[c].wpx || cols[c].width)) continue;
    let longest = min - pad;
    for (let r = range.s.r; r <= range.e.r; r++) {
      const cell = ws[utils.encode_cell({ r, c })];
      if (!cell || cell.v === undefined || cell.v === null) continue;
      let text;
      if (cell.t === "n") {
        const fmt = String(cell.z || "");
        text = fmt.includes("0.00")
          ? Number(cell.v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : String(cell.v);
        // Room for a currency prefix such as "AED " in the number format.
        if (/AED/i.test(fmt)) text = `AED ${text}`;
      } else {
        text = String(cell.w ?? cell.v);
      }
      const widest = text.split("\n").reduce((m, line) => Math.max(m, line.length), 0);
      if (widest > longest) longest = widest;
    }
    cols[c] = { ...(cols[c] || {}), wch: Math.min(max, Math.max(min, longest + pad)) };
  }
  ws["!cols"] = cols;
  return ws;
};
